import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDBox,
  FDContentContainer,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import ScenarioSelectionRedefinedWrapperHeader
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedWrapperHeader';
import { RightColumnProvider } from 'Context/RightColumnContext';
import { LayoutTabs } from 'Views/Page/Content/Templates/WhatIfClientRedefinedTemplate/LayoutTabs';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';

const WhatIfClientRedefinedLayout = ({ onAgentViewAllScenarios }) => {
  const { resource } = useMetaLayoutContext();

  useBoneBackgroundColor();

  return (
    <RightColumnProvider>

      <ScenarioSelectionRedefinedWrapperHeader resource={resource} onAgentViewAllScenarios={onAgentViewAllScenarios} />
      <FDContentContainer maxWidth={'xl'}>
        <LayoutTabs collection={resource.attr('tabs')} />

        <FDBox paddingY={2}>
          <FDBodyText
            size={'sm'}
            value={resource.attr('disclaimerText')}
            color={'textDisabled'}
            align={'center'}
          />
        </FDBox>
      </FDContentContainer>
    </RightColumnProvider>
  );
};

WhatIfClientRedefinedLayout.defaultProps = {
  onAgentViewAllScenarios: noop,
};

WhatIfClientRedefinedLayout.propTypes = {
  onAgentViewAllScenarios: PropTypes.func,
};

export default WhatIfClientRedefinedLayout;
